import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	title: {
		id: 'servicedesk-knowledge-common.create-category.create-category-stateless.title',
		defaultMessage: 'Create new category',
		description: 'Title of the create new category modal.',
	},
	createAction: {
		id: 'servicedesk-knowledge-common.create-category.create-category-stateless.create-action',
		defaultMessage: 'Create',
		description: 'Button text to submit the form and create a new category',
	},
	cancelAction: {
		id: 'servicedesk-knowledge-common.create-category.create-category-stateless.cancel-action',
		defaultMessage: 'Cancel',
		description: 'Button to close the create new category modal',
	},
});
